import { useTranslation } from "react-i18next";

interface CampaignBiddingStrategyCellProps {
  strategy: string | null;
}

const KNOWN_STRATEGIES = new Set(["LEGACY_FOR_SALES", "AUTO_FOR_SALES", "MANUAL", "RULE_BASED"]);

export function CampaignBiddingStrategyCell({ strategy }: CampaignBiddingStrategyCellProps) {
  const { t } = useTranslation("campaign");
  const label = strategy
    ? KNOWN_STRATEGIES.has(strategy)
      ? t(`list.biddingStrategy.${strategy}`)
      : strategy
    : "—";

  return (
    <span className="min-w-0 truncate text-ink" title={strategy ?? undefined}>
      {label}
    </span>
  );
}
